var filterFrame = {
    baseUrl: 'filter_window.phtml?sid=',
    handler: null,

    windowOpen: function (params, name, legacy) {

        if ( (baseDesign === undefined) || (baseDesign != 2017) ) {
            window.open(filterFrame.baseUrl + sid + '&' + params, name, legacy);
        } else {
            this.handler = new Ext.Window({
                title: name,
                width: 530,
                height: 600,
                layout: 'fit',
                items: [{
                    xtype: "component",
                    autoEl: {
                        style: {
                            "border-width": '0px'
                        },
                        tag: "iframe",
                        src: filterFrame.baseUrl + sid + '&' + params
                    }
                }]
            }).show();
        }


    },
    position: {
        costcenter: function (params, name, legacy) {
            filterFrame.windowOpen("assignmentmode=position&assignmenttype=costcenter&catalogpartnerid=" + params, name, legacy);
        },
        projectNumber: function (params, name, legacy) {
            filterFrame.windowOpen("assignmentmode=position&assignmenttype=projectnumber&catalogpartnerid=" + params, name, legacy);
        },
        pspNumber: function (params, name, legacy) {
            filterFrame.windowOpen("assignmentmode=position&assignmenttype=pspnumber&catalogpartnerid=" + params, name, legacy);
        },
        assetNo: function (params, name, legacy) {
            filterFrame.windowOpen("assignmentmode=position&assignmenttype=assetnumber&catalogpartnerid=" + params, name, legacy);

        },
        assignmentType: function (params, name, legacy) {
            filterFrame.windowOpen("assignmentmode=position&assignmenttype=assignmenttype_" + params, name, legacy);
        },
    },
    cart: {
        sachkonto: function (params, name, legacy) {
            filterFrame.windowOpen("assignmenttype=cart_sachkonto&retfield=cartform." + params, name, legacy);
        }
    }
}

